//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryMethodLangs', {
//        templateUrl: 'views/components/views/deliveryMethodLangs/deliveryMethodLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'deliveryMethodLangsService', function ($stateParams, stateService, modalService, translateService, deliveryMethodLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deliveryMethodNo = $stateParams.deliverymethod_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//            	let data = await translateService.translateBatch(translations);

//            	Object.keys(translations).forEach((key) => {
//            		if (data?.[key]) translations[key] = data[key];
//            	});
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadDeliveryMethodLanguages() {
//                vm.model.inputListLanguages = (await deliveryMethodLangsService.listDeliveryMethodLanguages({ deliverymethod_no: deliveryMethodNo }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                deliveryMethodLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadDeliveryMethodLanguages();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
